<template>
  <wb-modal mode="prompt" class="ti-unauthorized-modal">
    <wb-modal-content :headline="$t(headline)">
      {{ $t(copy) }}
    </wb-modal-content>

    <wb-modal-footer>
      <a
        :href="cancelUrl"
        type="button"
        class="ti-unauthorized-modal__cancel wb-button wb-button--secondary wb-button--large"
      >
        {{ $t('i18n.unauthorized.modal.cancel') }}
      </a>

      <button
        class="wb-button wb-button--primary wb-button--large"
        @click="login()"
        v-if="!loggedIn"
      >
        <wb-icon
          class="wb-button__icon"
          aria-hidden="true"
          flip-rtl
          name="chevron-right"
        ></wb-icon>
        {{ $t('i18n.meSearch.notLoggedIn.button') }}
      </button>

      <button
        class="wb-button wb-button--primary wb-button--large"
        @click="logout()"
        v-if="loggedIn"
      >
        {{ $t('i18n.meSearch.loggedIn.button') }}
      </button>
    </wb-modal-footer>
  </wb-modal>
</template>

<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue';
import {
  AUTHENTICATION_CONNECTION,
  IdentityProvider,
} from '@b2x/authentication-library';
import setup from '../../composables/setup';

const { wellKnownObjects, jweToken } = setup();
const cancelUrl = ref('');
const loggedIn = ref(false);
const headline = ref('i18n.unauthorized.modal.headline');
const copy = ref('i18n.unauthorized.modal.copy');

const { store } = setup();

const login = (): void => {
  store.value
    .getConnectionDispatchers(AUTHENTICATION_CONNECTION)
    .then((dispatchers) => {
      dispatchers.login({
        identityProvider: IdentityProvider.CIAS,
        tenantId: 'oneweb',
      });
    });
};

const logout = (): void => {
  store.value
    .getConnectionDispatchers(AUTHENTICATION_CONNECTION)
    .then((dispatchers) => {
      dispatchers.logout({ targetUrl: location.origin });
    });
};

watch(wellKnownObjects, () => {
  loggedIn.value = jweToken.value?.length ? true : false;

  if (loggedIn.value) {
    headline.value = 'i18n.unauthorized.modal.differentUserHeadline';
    copy.value = 'i18n.unauthorized.modal.differentUserCopy';
  }
});

onMounted(() => {
  const url: URL = new URL(window.location.href);
  url.searchParams.delete('tradeinid');
  cancelUrl.value = url.href;
});
</script>

<style lang="scss">
.ti-unauthorized-modal {
  @include breakpoint-to(mq3) {
    wb-modal-footer {
      :not(:last-child) {
        margin-bottom: 0;
      }
    }

    &__cancel {
      order: 2;
      margin-top: var(--wb-spacing-xs);
    }
  }
}
</style>
